import type { ReactNode } from 'react'

export function StandardPlanBox({
  children
}: { readonly children: ReactNode }) {
  return (
    <div
      data-testid="StandardPlanBox"
      className="border border-solid border-neutral-light-100 p-6 md:p-8 mx-auto max-w-6xl"
    >
      {children}
    </div>
  )
}
